import AnalyticsPage from './pages/analytics';
import AnalyticsDetailPage from './pages/analytics/detail';
// import NotFoundPage from './pages/not_found';

const routes = [
  {
    path: '/analytics/:section/:unit',
    component: AnalyticsDetailPage
  },
  {
    path: '/analytics',
    component: AnalyticsPage
  },
  // {
  //   path: '*',
  //   component: NotFoundPage
  // }
];

export default routes;
